var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "section",
      {
        staticClass: "content-padding-gray",
        class: _vm.$mq.phone ? "bg-white px-1 py-4" : "bg-gray"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xl-6 offset-xl-3 col-12" }, [
            _c("div", { class: { "card py-3 shadow-sm": !_vm.$mq.phone } }, [
              _c("div", { class: { "card-body": !_vm.$mq.phone } }, [
                _vm.step === 1
                  ? _c("section", [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("h2", { staticClass: "mb-3" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.service_request.service_request_notification"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", {}, [
                            _c("h3", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.booking_step.service"
                                    )
                                  ) +
                                  ": "
                              ),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$options.filters.serviceParentName(
                                      _vm.submitData.service_id,
                                      _vm.globalState.services
                                    )
                                  )
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.experience &&
                          _vm.experience.service &&
                          Number(_vm.experience.service.is_service_request) ===
                            1
                            ? _c("div", { staticClass: "pb-2" }, [
                                _c("div", { staticClass: "card shadow-sm" }, [
                                  _c("div", { staticClass: "card-body" }, [
                                    _c("div", { staticClass: "d-flex" }, [
                                      _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "img-selected-experience rounded-all"
                                          },
                                          [
                                            _c("img", {
                                              staticClass:
                                                "img-experience-photo",
                                              attrs: {
                                                src: _vm.experience.cover_photo,
                                                alt: ""
                                              }
                                            })
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "pl-3" }, [
                                        _c("strong", [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$options.filters.shortText(
                                                  _vm.experience.title,
                                                  100
                                                )
                                              )
                                            }
                                          })
                                        ]),
                                        _vm._v(" "),
                                        Number(_vm.experience.avg_rating) > 0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-small text-secondary pt-2"
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-star -rating-star mr-0"
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      Number(
                                                        _vm.experience
                                                          .avg_rating
                                                      ).toFixed(1)
                                                    ) +
                                                    "\n                              ·\n                              " +
                                                    _vm._s(
                                                      _vm.experience.num_rating
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$tc(
                                                        "message.professional.review",
                                                        _vm.experience
                                                          .num_rating
                                                      )
                                                    ) +
                                                    "\n                            "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.submitData.service_id === 13 ||
                      _vm.submitData.service_id === 49
                        ? _c("div", { staticClass: "row pb-3" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c("h4", { staticClass: "pb-2" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.service_request.big_cleaning_purpose"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "select-jumbo" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.submitData
                                            .service_request_purpose_id,
                                        expression:
                                          "submitData.service_request_purpose_id"
                                      }
                                    ],
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.submitData,
                                          "service_request_purpose_id",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._l(_vm.serviceRequestPurposes, function(
                                      data
                                    ) {
                                      return [
                                        _c(
                                          "option",
                                          { domProps: { value: data.id } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("multiLangName")(data)
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    })
                                  ],
                                  2
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "row py-3" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("h4", { staticClass: "pb-2" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.service_request.big_cleaning_service_date"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6 pr-0" }, [
                          _c("div", { staticClass: "mr-2" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "pikadayBooking",
                                  rawName: "v-pikadayBooking",
                                  value: _vm.calendarData,
                                  expression: "calendarData"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              ref: "cleaningDate",
                              staticClass:
                                "form-control -date-picker input-jumbo",
                              attrs: {
                                type: "text",
                                name: "serviceDate",
                                placeholder: _vm.$i18n.t(
                                  "message.booking.booking_step.date"
                                ),
                                readonly: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "far fa-calendar-alt input-text-icon"
                            }),
                            _vm._v(" "),
                            _vm.errors.has("serviceDate")
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mt-2 text-remark -status-alert"
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$t("message.required_field")
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6 pl-0" }, [
                          _c("div", { staticClass: "ml-2" }, [
                            _c("div", { staticClass: "select-jumbo" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.submitData.service_time,
                                      expression: "submitData.service_time"
                                    }
                                  ],
                                  staticStyle: { background: "white" },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.submitData,
                                        "service_time",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.globalState.arrTimes, function(
                                  time
                                ) {
                                  return _c(
                                    "option",
                                    { domProps: { value: time } },
                                    [_vm._v(_vm._s(time))]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "far fa-clock input-text-icon"
                              })
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.displayBuildingType
                        ? _c("div", { staticClass: "row py-3" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c("h4", { staticClass: "pb-2" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.service_request.big_cleaning_building_type"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "select-jumbo" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.submitData.building_type_id,
                                        expression:
                                          "submitData.building_type_id"
                                      }
                                    ],
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.submitData,
                                          "building_type_id",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._l(
                                      _vm.globalState.configData.building_types,
                                      function(data) {
                                        return [
                                          _c(
                                            "option",
                                            { domProps: { value: data.id } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("multiLangName")(data)
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    )
                                  ],
                                  2
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "row py-3" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("h4", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.submitData.service_id === 49
                                    ? _vm.$t(
                                        "message.service_request.upholstery_cleaning_size"
                                      )
                                    : _vm.$t(
                                        "message.service_request.big_cleaning_building_size"
                                      )
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-remark mb-2" }, [
                            _c("i", {
                              staticClass: "fas fa-circle fa-xs -status-pending"
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.submitData.service_id === 49
                                    ? _vm.$t(
                                        "message.service_request.upholstery_cleaning_size_remark"
                                      )
                                    : _vm.$t(
                                        "message.service_request.big_cleaning_building_size_remark"
                                      )
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.submitData.building_size,
                                expression: "submitData.building_size"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "form-alert": _vm.errors.has("buildingSize")
                            },
                            attrs: {
                              name: "buildingSize",
                              id: "buildingSize",
                              placeholder:
                                _vm.submitData.service_id === 49
                                  ? _vm.$i18n.t(
                                      "message.service_request.upholstery_cleaning_size_placeholder"
                                    )
                                  : _vm.$i18n.t(
                                      "message.service_request.big_cleaning_building_size_placeholder"
                                    )
                            },
                            domProps: { value: _vm.submitData.building_size },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.submitData,
                                  "building_size",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors.has("buildingSize")
                            ? _c(
                                "div",
                                {
                                  staticClass: "mt-2 text-remark -status-alert"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("message.required_field")) +
                                      "\n                  "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row pt-3" }, [
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-lg btn-info btn-block -cyan",
                              on: {
                                click: function($event) {
                                  return _vm.nextStep()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.new_booking.continue"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  : _vm.step === 2
                  ? _c("section", [
                      _c("div", { staticClass: "row py-3" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("h4", { staticClass: "pb-2" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.service_request.big_cleaning_building_address"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "tel" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.booking.contact_step.phone")
                              )
                            ),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.submitData.tel,
                                expression: "submitData.tel"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  min: 10,
                                  max: 15,
                                  regex: /^\+?[0-9-]+$/
                                },
                                expression:
                                  "{ required: true, min: 10, max: 15, regex: /^\\+?[0-9-]+$/ }"
                              }
                            ],
                            ref: "tel",
                            staticClass: "form-control input-jumbo",
                            class: { "form-alert": _vm.errors.has("tel") },
                            attrs: { type: "tel", id: "tel", name: "tel" },
                            domProps: { value: _vm.submitData.tel },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.submitData,
                                  "tel",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors.has("tel")
                            ? _c(
                                "div",
                                {
                                  staticClass: "mt-1 text-remark -status-alert"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("message.required_field")) +
                                      "\n                  "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("label", { attrs: { for: "address" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.booking.contact_step.address")
                              ) +
                                " - " +
                                _vm._s(
                                  _vm.$t(
                                    "message.booking.contact_step.address_remark"
                                  )
                                )
                            ),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.submitData.building_address,
                                expression: "submitData.building_address"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            ref: "address",
                            staticClass: "form-control input-jumbo",
                            class: { "form-alert": _vm.errors.has("address") },
                            attrs: {
                              type: "text",
                              id: "address",
                              name: "address"
                            },
                            domProps: {
                              value: _vm.submitData.building_address
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.submitData,
                                  "building_address",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors.has("address")
                            ? _c(
                                "div",
                                {
                                  staticClass: "mt-1 text-remark -status-alert"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("message.required_field")) +
                                      "\n                  "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col pt-3" }, [
                          _c("label", { attrs: { for: "addressProvince" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.business.contact_province")
                              )
                            ),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "select-jumbo mb-3" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.submitData.address_province_id,
                                    expression: "submitData.address_province_id"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                class: {
                                  "form-alert": _vm.errors.has(
                                    "addressProvince"
                                  )
                                },
                                attrs: {
                                  id: "addressProvince",
                                  name: "addressProvince"
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.submitData,
                                      "address_province_id",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c("option", { domProps: { value: null } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message.booking.contact_step.set_province"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.sortedProvinces, function(
                                  addressProvince,
                                  index
                                ) {
                                  return _c(
                                    "option",
                                    { domProps: { value: addressProvince.id } },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm._f("multiLangName")(
                                              addressProvince
                                            )
                                          ) +
                                          "\n                      "
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _vm.errors.has("addressProvince")
                            ? _c(
                                "div",
                                {
                                  staticClass: "mt-1 text-remark -status-alert"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("message.required_field")) +
                                      "\n                  "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-6 pr-2" }, [
                          _c("label", { attrs: { for: "district" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.booking.contact_step.district")
                              )
                            ),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "select-jumbo" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.submitData.district_id,
                                    expression: "submitData.district_id"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                class: {
                                  "form-alert": _vm.errors.has("district")
                                },
                                attrs: { id: "district", name: "district" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.submitData,
                                      "district_id",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c("option", { domProps: { value: null } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message.booking.contact_step.set_district"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.sortedDistricts, function(
                                  district,
                                  index
                                ) {
                                  return _c(
                                    "option",
                                    { domProps: { value: district.id } },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm._f("multiLangName")(district)
                                          ) +
                                          "\n                      "
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _vm.errors.has("district")
                            ? _c(
                                "div",
                                {
                                  staticClass: "mt-1 text-remark -status-alert"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("message.required_field")) +
                                      "\n                  "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6 pl-2" }, [
                          _c("label", { attrs: { for: "sub-district" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.booking.contact_step.sub_district"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "select-jumbo" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.submitData.sub_district_id,
                                    expression: "submitData.sub_district_id"
                                  }
                                ],
                                attrs: { id: "sub-district" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.submitData,
                                      "sub_district_id",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c("option", { domProps: { value: null } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message.booking.contact_step.set_sub_district"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.sortedSubDistricts, function(
                                  subDistrcict,
                                  index
                                ) {
                                  return _c(
                                    "option",
                                    { domProps: { value: subDistrcict.id } },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm._f("multiLangName")(
                                              subDistrcict
                                            )
                                          ) +
                                          "\n                      "
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "row py-3" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("h4", { staticClass: "pb-2" }, [
                              _c("i", { staticClass: "fal fa-images fa-lg" }),
                              _vm._v(
                                "  " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.service_request.big_cleaning_attach_photos"
                                    )
                                  ) +
                                  "\n                    "
                              ),
                              _vm.errorNoUploadPhoto
                                ? _c("span", { staticClass: "text-danger" }, [
                                    _c("i", {
                                      staticClass: "fa fa-exclamation-circle"
                                    })
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-remark mb-2" }, [
                              _c("i", {
                                staticClass:
                                  "fas fa-circle fa-sm -status-pending"
                              }),
                              _vm._v(
                                " \n                    " +
                                  _vm._s(
                                    _vm.submitData.service_id === 49
                                      ? _vm.$t(
                                          "message.service_request.upholstery_cleaning_attach_photos_remark"
                                        )
                                      : _vm.$t(
                                          "message.service_request.big_cleaning_attach_photos_remark"
                                        )
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("vue-dropzone", {
                              ref: "vueDropzone",
                              staticClass: "dropzone-dashed",
                              attrs: {
                                id: "dropzone",
                                options: _vm.dropzoneOptions
                              },
                              on: {
                                "vdropzone-file-added": _vm.clearFileUploadError
                              }
                            }),
                            _vm._v(" "),
                            _vm.errorNoUploadPhoto
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mt-2 text-remark -status-alert"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.required_photo_attachment"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row pt-3" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("h4", { staticClass: "pb-2" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.service_request.big_cleaning_remark"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.submitData.remark,
                                expression: "submitData.remark"
                              }
                            ],
                            ref: "remark",
                            staticClass: "form-control textarea-jumbo",
                            attrs: {
                              rows: "2",
                              id: "remark",
                              placeholder: _vm.$i18n.t(
                                "message.service_request.big_cleaning_remark_placeholder"
                              )
                            },
                            domProps: { value: _vm.submitData.remark },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.submitData,
                                  "remark",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", { staticClass: "row py-3" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("h4", { staticClass: "pb-2 text-orange" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.service_request.service_request_condition_title"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("ul", { staticClass: "list-unstyled" }, [
                            _c("li", { staticClass: "pb-3" }, [
                              _c("i", {
                                staticClass:
                                  "fas fa-circle fa-xs -status-pending"
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.service_request.service_request_remark01"
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", { staticClass: "pb-3" }, [
                              _c("i", {
                                staticClass:
                                  "fas fa-circle fa-xs -status-pending"
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.service_request.service_request_remark02"
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("i", {
                                staticClass:
                                  "fas fa-circle fa-xs -status-pending"
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.submitData.service_id === 49
                                      ? _vm.$t(
                                          "message.service_request.service_request_remark04"
                                        )
                                      : _vm.$t(
                                          "message.service_request.service_request_remark03"
                                        )
                                  ) +
                                  "\n                    "
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col text-center" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-lg btn-info btn-block -cyan",
                              attrs: { disabled: _vm.isSubmitting },
                              on: {
                                click: function($event) {
                                  return _vm.submitRequest()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.isSubmitting
                                      ? _vm.$t("message.button.loading")
                                      : _vm.$t("message.button.submit_request")
                                  ) +
                                  "\n                  "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "pt-4" }, [
                            _c(
                              "a",
                              {
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.backToFirstStep()
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fas fa-angle-left" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("message.button.back")) +
                                    "\n                    "
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.service
      ? _c("section", { staticClass: "section-padding d-none d-lg-block" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c("div", { staticClass: "col-md-8 col-12" }, [
                _c("h2", { staticClass: "text-center" }, [
                  _vm._v(_vm._s(_vm.$t("message.big_cleaning.service_detail")))
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$i18n.locale === "th"
                        ? _vm.service.detail_th
                        : _vm.service.detail_en
                    )
                  }
                })
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row pt-3" }, [
      _c("div", { staticClass: "col" }, [_c("hr")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row pt-3" }, [
      _c("div", { staticClass: "col" }, [_c("hr")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-215a7954", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-215a7954","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/serviceRequest/Booking.vue
// module id = 2059
// module chunks = 0